import { forwardRef, HTMLAttributes, HTMLProps } from 'react';

import { Chip, ChipProps } from './Chip';

export type ChipLinkProps = HTMLAttributes<HTMLAnchorElement> &
  Omit<ChipProps, 'component'> &
  Pick<HTMLProps<HTMLAnchorElement>, 'href'>;

export const ChipLink = forwardRef<HTMLDivElement, ChipLinkProps>((props, ref) => (
  <Chip {...props} component='a' ref={ref} />
));

ChipLink.displayName = 'ChipLink';
